import { defineComponent, ref, onMounted } from 'vue'
import MapPage from '@/organizations/_default/map'
import FilterInfo from '@/organizations/cosmo/default/components/FilterInfo.vue'
import CosmoHeader from '@/organizations/cosmo/default/components/CosmoHeader.vue'
import CosmoFooter from '@/organizations/cosmo/default/components/CosmoFooter.vue'
import { Filters } from '@/services/Filters.ts'
import ProductModal from '@/components/common/ProductModal.vue'

export default defineComponent({
  extends: MapPage,
  components: {
    FilterInfo,
    CosmoHeader,
    CosmoFooter,
    ProductModal,
  },
  setup(props, context) {
    const page = MapPage.setup(props, context)

    const selectedSearchCondition = ref({})
    /**
     * コンポーネントの名前に合わせて変数名をproductModalRefとするが
     * モーダルに表示する内容は絞り込みの説明
     */
    const productModalRef = ref(null)

    /**
     * FileterInfoのクリックイベント
     * 共通のproductModalを利用するために、propsで設定する
     */
    const showProductModal = (searchConditionId) => {
      selectedSearchCondition.value = Filters.findById(Filters.TYPE_SEARCH_CONDITIONS, searchConditionId)
      productModalRef.value.open()

      storelocator.analytics.client?.send('SelectSearchCondition', {
        SearchConditionId: selectedSearchCondition.value.id,
        SearchConditionName: selectedSearchCondition.value.name,
      })
    }

    return {
      ...page,
      selectedSearchCondition,
      productModalRef,
      showProductModal,
    }
  }
})
